export const FETCH_SERVICE_HISTORY_START = "FETCH_SERVICE_HISTORY_START";
export const FETCH_SERVICE_HISTORY_SUCCESS = "FETCH_SERVICE_HISTORY_SUCCESS";
export const FETCH_SERVICE_HISTORY_FAIL = "FETCH_SERVICE_HISTORY_FAIL";

export const UPDATE_SERVICE_HISTORY_START = "UPDATE_SERVICE_HISTORY_START";
export const UPDATE_SERVICE_HISTORY_SUCCESS = "UPDATE_SERVICE_HISTORY_SUCCESS";
export const UPDATE_SERVICE_HISTORY_FAIL = "UPDATE_SERVICE_HISTORY_FAIL";

export const DELETE_SERVICE_HISTORY_START = "DELETE_SERVICE_HISTORY_START";
export const DELETE_SERVICE_HISTORY_SUCCESS = "DELETE_SERVICE_HISTORY_SUCCESS";
export const DELETE_SERVICE_HISTORY_FAIL = "DELETE_SERVICE_HISTORY_FAIL";

export const UPDATE_SERVICE_HISTORY_IMAGES_START = "UPDATE_SERVICE_HISTORY_IMAGES_START";
export const UPDATE_SERVICE_HISTORY_IMAGES_SUCCESS = "UPDATE_SERVICE_HISTORY_IMAGES_SUCCESS";
export const UPDATE_SERVICE_HISTORY_IMAGES_FAIL = "UPDATE_SERVICE_HISTORY_IMAGES_FAIL";
